import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

import { ReviewParticipantsContext } from 'modules/reviews/pages/performance/Show/Participants/context'
import { useReviewShowContext } from 'modules/reviews/pages/performance/Show/hooks'
import type FormAccessGroupMembership from 'modules/reviews/store/models/FormAccessGroupMembership'
import type Review from 'modules/reviews/store/models/v2/Review'

type PopoverContentProps = React.ComponentProps<typeof PopoverContent>

interface EditProps {
  user: User
  form: Review
  membership: FormAccessGroupMembership
}

const EditButton = ({ form, membership }: EditProps) => {
  const [open, toggle] = useToggle()
  const { canEditReview, updateCanBeStarted } = useReviewShowContext()
  const { fetchReviewees } = React.useContext(ReviewParticipantsContext)

  const { performAction: destroy } = useAsyncAction(async () => {
    await membership.destroy({ data: { form_id: form?.attributes.id } })
    fetchReviewees()
    await updateCanBeStarted()
  })

  const options: PopoverContentProps['options'] = [
    {
      title: i18n.t('surveys.form.participants.table.body.edit.delete.review'),
      type: 'wrong',
      onClick: (event) => {
        event.stopPropagation()
        destroy()
      },
    },
  ]

  const canEdit = form && canEditReview && form.isDraft

  if (!canEdit) return null

  return (
    <Popover
      attachment="top center"
      targetAttachment="bottom center"
      withPreventDefault
      toggle={toggle}
      open={open}
    >
      <Button
        aria-label="Participant options"
        onClick={toggle(true)}
        type="secondary"
        iconName="ellipsis"
      />
      <PopoverContent onClose={toggle(false)} options={options} />
    </Popover>
  )
}

export default observer(EditButton)
